module.exports = __webpack_public_path__ + "static/media/2_evenement.10388012.jpg";